import React, { useEffect, useState } from 'react';

function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDarkTheme, setIsDarkTheme] = useState(false);

  useEffect(() => {
    const scrollButton = document.querySelector('.scroll-top');
    const menuBtn = document.getElementById('menu-btn');
    const header = document.querySelector('.header');

    
    scrollButton.style.display = 'none';
    
    const toggleMenu = () => {
      setIsMenuOpen(prevState => !prevState);
    };

    const closeMenu = () => {
      setIsMenuOpen(false);
    };

    menuBtn.addEventListener('click', toggleMenu);
    document.querySelectorAll('.navbar a').forEach(link => {
      link.addEventListener('click', closeMenu);
    });

    const toggleStickyHeader = () => {
      if (window.scrollY > 0) {
        header.classList.add('sticky');
      } else {
        header.classList.remove('sticky');
      }

      if (window.scrollY > 100) {
        scrollButton.style.display = 'block';
      } else {
        scrollButton.style.display = 'none';
      }
    };

    window.addEventListener('scroll', toggleStickyHeader);

    return () => {
      menuBtn.removeEventListener('click', toggleMenu);
      document.querySelectorAll('.navbar a').forEach(link => {
        link.removeEventListener('click', closeMenu);
      });
      window.removeEventListener('scroll', toggleStickyHeader);
    };
  }, []);
  const toggleTheme = () => {
    setIsDarkTheme(prevState => !prevState);
    document.body.classList.toggle('theme-white');
  };
  return (
    <div className="navigation">
      <a href="#container" className="scroll-top">
        <i className="fas fa-angle-up"></i>
      </a>
      <header className="header">
        <a className="logo" href="#container">
          <h2>Romain</h2>
          <button onClick={toggleTheme} className="theme-toggle">
            <i className={`fas ${isDarkTheme ? 'fa-moon' : 'fa-sun'}`}></i>
          </button>
        </a>
        <nav className={`navbar ${isMenuOpen ? 'active' : ''}`}>
          <a href="#container">home</a>
          <a href="#about-me">about</a>
          <a href="#projects">portfolio</a>
          <a href="#contact">contact</a>
        </nav>
        <div className={`fas fa-bars ${isMenuOpen ? 'active' : ''}`} id="menu-btn"></div>
      </header>
    </div>
  );
}

export default Navigation;
